// extracted by css-extract-rspack-plugin
export default {"cls1":"TabbedPreviewList-cls1_dT2","cls2":"TabbedPreviewList-cls2_T-W TabbedPreviewList-cls1_dT2"};